/**
 * Layout-related constants
 */

const LayoutConstants = {
  // Character limits
  NOTES_MAX_CHARACTERS: 8000,
  TABLE_VERTICAL_CROP_ZONES_SCROLL: 'calc(100vh - 373px)',
  TABLE_VERTICAL_PRODUCTS_SCROLL: 'calc(100vh - 358px)',
  TABLE_VERTICAL_PRODUCTS_SCROLL_WITH_TANK_INFO: 'calc(100vh - 484px)'
} as const;

export default LayoutConstants;
